import './SellingServices.css';

function SellingServices() {
  return (
    <div className="selling-services">
      <div className="container">
        <section className="selling-content">
          <div className="service-details">
            <h2>What I Do for Sellers</h2>
            <p>
              I know selling a home is both a financial and emotional decision, so I focus on maximizing your return while making the process seamless.
            </p>
            
            <div className="selling-process">
              <h3>My Proven Selling Process</h3>
              <div className="process-steps">
                <div className="step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h4>Initial Consultation</h4>
                    <p>We discuss your goals, timeline, and expectations for the sale.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h4>Market Analysis</h4>
                    <p>Comprehensive evaluation of your home's value and local market conditions.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h4>Preparation & Staging</h4>
                    <p>Recommendations for improvements and professional staging to maximize appeal.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h4>Smart Pricing Strategy</h4>
                    <p>Strategic pricing based on market analysis to attract qualified buyers and maximize your return.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">5</div>
                  <div className="step-content">
                    <h4>Marketing Launch</h4>
                    <p>Professional photography, listing, and comprehensive marketing campaign.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">6</div>
                  <div className="step-content">
                    <h4>Offers & Negotiation</h4>
                    <p>Expert negotiation to secure the best possible terms for your sale.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">7</div>
                  <div className="step-content">
                    <h4>Closing</h4>
                    <p>Smooth transaction management from acceptance to closing day.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <section className="contact-section">
          <div className="contact-card">
            <h3>Ready to Sell Your Home?</h3>
            <p>Let's discuss your selling goals and create a customized strategy for your property.</p>
            <div className="contact-buttons">
              <span className="phone-desktop">(650) 283-3537</span>
              <a href="tel:650-283-3537" className="phone-mobile contact-btn primary">Call (650) 283-3537</a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default SellingServices;